import { render, staticRenderFns } from "./zpxq.vue?vue&type=template&id=b0a31648"
import script from "./zpxq.vue?vue&type=script&lang=js"
export * from "./zpxq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports